if (!customElements.get('learn-handoff')) {
  class LearnHandoff extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode) return;

      const step = 140;
      const typical = Array.from(this.querySelectorAll('.learn-brand-comparison__step'));
      const ours = Array.from(this.querySelectorAll('.learn-brand-comparison__segment'));
      typical.forEach((el, i) => el.style.setProperty('--reveal-delay', `${i * step}ms`));
      const oursStart = typical.length * step + 300;
      ours.forEach((el, i) => el.style.setProperty('--reveal-delay', `${oursStart + i * step}ms`));
      const oursDuration = Math.max(ours.length * step, 400);
      this.style.setProperty('--grow-delay', `${oursStart}ms`);
      this.style.setProperty('--grow-duration', `${oursDuration}ms`);

      this.counters = [
        { el: this.querySelector('.learn-brand-comparison__track--typical [data-count-to]'), delay: 0, duration: typical.length * step },
        { el: this.querySelector('.learn-brand-comparison__track--ours [data-count-to]'), delay: oursStart, duration: oursDuration },
      ].filter((c) => c.el && !Number.isNaN(parseInt(c.el.dataset.countFrom, 10)) && !Number.isNaN(parseInt(c.el.dataset.countTo, 10)));
      this.counters.forEach((c) => (c.el.textContent = c.el.dataset.countFrom));

      this.classList.add('is-armed');
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.reveal();
        },
        { threshold: 0.35 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    reveal() {
      requestAnimationFrame(() => this.classList.add('is-revealed'));
      this.counters.forEach(({ el, delay, duration }) => {
        const from = parseInt(el.dataset.countFrom, 10);
        const to = parseInt(el.dataset.countTo, 10);
        setTimeout(() => {
          const start = performance.now();
          const tick = (now) => {
            const t = Math.min(1, (now - start) / duration);
            el.textContent = String(Math.round(from + (to - from) * t));
            if (t < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }, delay);
      });
    }
  }

  customElements.define('learn-handoff', LearnHandoff);
}
